import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommercePerformanceReportNetSalesEntityState} from "../reducers/ecommerce-performance-net-sales.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommercePerformanceReportNetSalesState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommercePerformanceReportNetSales.entities[websiteId]);

export const getEcommercePerformanceReportNetSales = (websiteId: number) => createSelector(getEcommercePerformanceReportNetSalesState(websiteId),
  (state: IEcommercePerformanceReportNetSalesEntityState) => {
      return state.netSalesData;
  }
);

export const getEcommercePerformanceReportNetSalesLoading = (websiteId: number) => createSelector(getEcommercePerformanceReportNetSalesState(websiteId),
  (state: IEcommercePerformanceReportNetSalesEntityState) => state && state.loading
);

export const getEcommercePerformanceReportNetSalesLoaded = (websiteId: number) => createSelector(getEcommercePerformanceReportNetSalesState(websiteId),
  (state: IEcommercePerformanceReportNetSalesEntityState) => state && state.loaded
);
